import { render, staticRenderFns } from "./noticeRectification.vue?vue&type=template&id=073f547f&scoped=true"
import script from "./noticeRectification.vue?vue&type=script&lang=js"
export * from "./noticeRectification.vue?vue&type=script&lang=js"
import style0 from "./noticeRectification.vue?vue&type=style&index=0&id=073f547f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073f547f",
  null
  
)

export default component.exports